import React, { useState } from "react";
import CustomInput from "../AuthenticationComponents/CustomInput";
import CustomButton from "../AuthenticationComponents/CustomButton";
import arrowRightIcon from "../../assets/images/authentication/arrow-right.svg";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "./LegalBusinessNameModal.scss";

const LegalBusinessNameModal = ({ isOpen, onSubmit }) => {
  const [legalBusinessName, setLegalBusinessName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    // Validation
    if (!legalBusinessName || legalBusinessName.trim() === "") {
      setError("Legal business name is required");
      return;
    }

    if (legalBusinessName.trim().length < 2) {
      setError("Legal business name must be at least 2 characters");
      return;
    }

    setError("");
    setSubmitting(true);

    try {
      await onSubmit(legalBusinessName.trim());
      // Success - parent will handle closing the modal
      setLegalBusinessName("");
    } catch (err) {
      console.error("Failed to submit legal business name:", err);
      setError("Failed to update. Please try again.");
      toastr.error("Failed to update legal business name");
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="legal-business-name-modal__overlay" role="dialog" aria-modal="true">
      <div className="legal-business-name-modal__card">
        {/* Icon/Glyph */}
        <div className="legal-business-name-modal__glyph" aria-hidden="true">
          <div className="legal-business-name-modal__glyph-core">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path
                d="M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M16 10v6l4 2"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="legal-business-name-modal__title">
          Add Your Legal Business Name
        </h2>

        {/* Message */}
        <p className="legal-business-name-modal__message">
          To complete your restaurant setup, please provide your legal business name.
        </p>

        {/* Why we need it section */}
        <div className="legal-business-name-modal__why-section">
          <h3 className="legal-business-name-modal__why-title">Why we need it</h3>
          <ul className="legal-business-name-modal__why-list">
            <li>Capture member dining transactions</li>
            <li>Track rewards and voucher redemptions</li>
            <li>Keep your restaurant records accurate</li>
          </ul>
        </div>

        {/* Note section */}
        <div className="legal-business-name-modal__note">
          <span className="legal-business-name-modal__note-label">Note:</span>
          <span className="legal-business-name-modal__note-text">
            Your legal business name is the official name registered for your business. It may be different from your restaurant name and shown on your business registration documents.
          </span>
        </div>

        {/* Input Field */}
        <div className="legal-business-name-modal__input-wrapper">
          <CustomInput
            id="legalBusinessName"
            label="Legal Business Name"
            name="legalBusinessName"
            type="text"
            placeholder="Enter your legal business name"
            value={legalBusinessName}
            onChange={(e) => {
              setLegalBusinessName(e.target.value);
              setError("");
            }}
            invalid={!!error}
            errorText={error}
            disabled={submitting}
            className="white-bg"
          />
        </div>

        {/* Submit Button */}
        <div className="legal-business-name-modal__button-wrapper">
          <CustomButton
            type="button"
            variant="primary"
            onClick={handleSubmit}
            disabled={submitting || !legalBusinessName.trim()}
            loading={submitting}
            icon={arrowRightIcon}
            iconPosition="right"
            className="w-100"
          >
            Submit
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default LegalBusinessNameModal;
